<template>
  <div class="w-full h-full mt-52">
    <LoadingSpinner />
  </div>
</template>

<script>
import LoadingSpinner from "./LoadingSpinner.vue"
export default {
  components: {
    LoadingSpinner
  },
}
</script>